/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Trans } from "react-i18next";
import OrganizationCard from "./OrganizationCard";

class FordOrganization extends Component {
  state = { currentTab: "#plan" };

  render() {
    return (
      <section className="profilArea my-3">
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Kurumsal">10026</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Ford Organizasyon">10040</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Ford Organizasyon">10040</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <Tab.Container
                id="nav-tab"
                defaultActiveKey="#general"
                activeKey={this.state.currentTab}
              >
                <nav className="scrollNav">
                  <Nav variant="tabs" role="tablist" className="fordOrgNav">
                    <Nav.Item>
                      <Nav.Link
                        onClick={() => this.setState({ currentTab: "#plan" })}
                        eventKey="#plan"
                      >
                        <span className="iconmford fo-icon-featured-play-list"></span>{" "}
                        <Trans desc="Planlama ve Geliştirme">10188</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() =>
                          this.setState({ currentTab: "#vehicles" })
                        }
                        eventKey="#vehicles"
                      >
                        <span className="iconmford fo-icon-directions-car"></span>
                        <Trans desc="Ticari Araçlar">10189</Trans>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className="nav-item nav-link"
                        onClick={() =>
                          this.setState({ currentTab: "#fordtrucks" })
                        }
                        eventKey="#fordtrucks"
                      >
                        <span className="iconmford fo-icon-local-shipping"></span>{" "}
                        <Trans desc="FordTrucks">10190</Trans>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </nav>
                <Tab.Content>
                  <Tab.Pane eventKey="#plan">
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>efkangucvar_fullname</Trans>,
                          title: <Trans>efkangucvar_title</Trans>,
                          profileImage: "img/deryagulunay.jpg",
                          phone: "+902165647263",
                          formattedPhone: "+90 216 564 72 63",
                          mail: "dgulunay@ford.com.tr", //"egucvard@ford.com.tr",
                          responsibilities: [
                            <Trans>efkangucvar_responsibility1</Trans>,
                            <Trans>efkangucvar_responsibility2</Trans>,
                            <Trans>efkangucvar_responsibility3</Trans>,
                            <Trans>efkangucvar_responsibility4</Trans>,
                            <Trans>efkangucvar_responsibility5</Trans>,
                            <Trans>efkangucvar_responsibility6</Trans>,
                            <Trans>efkangucvar_responsibility7</Trans>,
                            <Trans>efkangucvar_responsibility8</Trans>,
                            <Trans>efkangucvar_responsibility9</Trans>,
                          ],
                        }}
                      />
                    </div>
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>yunusturkili_fullname</Trans>,
                          title: <Trans>yunusturkili_title</Trans>,
                          profileImage: "img/ford-personel-yunus-turkili.jpg",
                          phone: "+902165647311",
                          formattedPhone: "+90 216 564 73 11",
                          mail: "yturkili@ford.com.tr",
                          responsibilities: [
                            <Trans>yunusturkili_responsibility1</Trans>,
                            <Trans>yunusturkili_responsibility2</Trans>,
                            <Trans>yunusturkili_responsibility3</Trans>,
                            <Trans>yunusturkili_responsibility4</Trans>,
                            <Trans>yunusturkili_responsibility5</Trans>,
                            <Trans>yunusturkili_responsibility6</Trans>,
                            <Trans>yunusturkili_responsibility7</Trans>,
                            <Trans>yunusturkili_responsibility8</Trans>,
                            <Trans>yunusturkili_responsibility9</Trans>,
                          ],
                        }}
                      />

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>ferahyetkin_fullname</Trans>,
                          title: <Trans>ferahyetkin_title</Trans>,
                          profileImage:
                            "img/ford-personel-ferah-yetkin-percin.jpg",
                          phone: "+902165647153",
                          formattedPhone: "+90 216 564 71 53",
                          mail: "fpercin@ford.com.tr",
                          responsibilities: [
                            <Trans>ferahyetkin_responsibility1</Trans>,
                            <Trans>ferahyetkin_responsibility2</Trans>,
                            <Trans>ferahyetkin_responsibility3</Trans>,
                            <Trans>ferahyetkin_responsibility4</Trans>,
                            <Trans>ferahyetkin_responsibility5</Trans>,
                            <Trans>ferahyetkin_responsibility6</Trans>,
                            <Trans>ferahyetkin_responsibility7</Trans>,
                            <Trans>ferahyetkin_responsibility8</Trans>,
                            <Trans>ferahyetkin_responsibility9</Trans>,
                            <Trans>ferahyetkin_responsibility10</Trans>,
                          ],
                        }}
                      />
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>canocan_fullname</Trans>,
                          title: <Trans>canocan_title</Trans>,
                          profileImage: "img/ford-personel-can-ozcan.jpg",
                          phone: "+902165647162",
                          formattedPhone: "+90 216 564 71 62",
                          mail: "cozcan3@ford.com.tr",
                          responsibilities: [
                            <Trans>canocan_responsibility1</Trans>,
                            <Trans>canocan_responsibility2</Trans>,
                            <Trans>canocan_responsibility3</Trans>,
                            <Trans>canocan_responsibility4</Trans>,
                            <Trans>canocan_responsibility5</Trans>,
                            <Trans>canocan_responsibility6</Trans>,
                            <Trans>canocan_responsibility7</Trans>,
                            <Trans>canocan_responsibility8</Trans>,
                            <Trans>canocan_responsibility9</Trans>,
                          ],
                        }}
                      />
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>dicleerim_fullname</Trans>,
                          title: <Trans>dicleerim_title</Trans>,
                          profileImage: "img/ford-personel-dicle-erim.jpg",
                          phone: "+902165647260",
                          formattedPhone: "+90 216 564 72 60",
                          mail: "derim@ford.com.tr",
                          responsibilities: [
                            <Trans>dicleerim_responsibility1</Trans>,
                            <Trans>dicleerim_responsibility2</Trans>,
                            <Trans>dicleerim_responsibility3</Trans>,
                            <Trans>dicleerim_responsibility4</Trans>,
                            <Trans>dicleerim_responsibility5</Trans>,
                            <Trans>dicleerim_responsibility6</Trans>,
                            <Trans>dicleerim_responsibility7</Trans>,
                            <Trans>dicleerim_responsibility8</Trans>,
                            <Trans>dicleerim_responsibility9</Trans>,
                            <Trans>dicleerim_responsibility10</Trans>,
                            <Trans>dicleerim_responsibility11</Trans>,
                          ],
                        }}
                      />
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>erdilicten_fullname</Trans>,
                          title: <Trans>erdilicten_title</Trans>,
                          profileImage: "img/ford-personel-erdil-icten.png",
                          phone: "+902165647163",
                          formattedPhone: "+90 216 564 71 63",
                          mail: "eicten@ford.com.tr",
                          responsibilities: [
                            <Trans>erdilicten_responsibility1</Trans>,
                            <Trans>erdilicten_responsibility2</Trans>,
                            <Trans>erdilicten_responsibility3</Trans>,
                          ],
                        }}
                      />
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>esracavak_fullname</Trans>,
                          title: <Trans>esracavak_title</Trans>,
                          profileImage: "img/ford-personel-esra-cavak.png",
                          mail: "ecavak@ford.com.tr",
                          responsibilities: [
                            <Trans>esracavak_responsibility1</Trans>,
                            <Trans>esracavak_responsibility2</Trans>,
                            <Trans>esracavak_responsibility3</Trans>,
                            <Trans>esracavak_responsibility4</Trans>,
                            <Trans>esracavak_responsibility5</Trans>,
                            <Trans>esracavak_responsibility6</Trans>,
                            <Trans>esracavak_responsibility7</Trans>,
                            <Trans>esracavak_responsibility8</Trans>,
                            <Trans>esracavak_responsibility9</Trans>,
                          ],
                        }}
                      />

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>kutluhan_akkor_fullname</Trans>,
                          title: <Trans>kutluhan_akkor_title</Trans>,
                          profileImage: "img/ford-personel-kutluhan-akkor.png",
                          mail: "kakkor1@ford.com.tr",
                          responsibilities: [
                            <Trans>kutluhan_akkor_responsibility1</Trans>,
                            <Trans>kutluhan_akkor_responsibility2</Trans>,
                            <Trans>kutluhan_akkor_responsibility3</Trans>,
                            <Trans>kutluhan_akkor_responsibility4</Trans>,
                            <Trans>kutluhan_akkor_responsibility5</Trans>,
                            <Trans>kutluhan_akkor_responsibility6</Trans>,
                            <Trans>kutluhan_akkor_responsibility7</Trans>,
                          ],
                        }}
                      />

                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="#vehicles">
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>efkangucvar_fullname</Trans>,
                          title: <Trans>efkangucvar_title</Trans>,
                          profileImage: "img/deryagulunay.jpg",
                          phone: "+902165647263",
                          formattedPhone: "+90 216 564 72 63",
                          mail: "", //"egucvard@ford.com.tr",
                          responsibilities: [
                            <Trans>efkangucvar_responsibility1</Trans>,
                            <Trans>efkangucvar_responsibility2</Trans>,
                            <Trans>efkangucvar_responsibility3</Trans>,
                            <Trans>efkangucvar_responsibility4</Trans>,
                            <Trans>efkangucvar_responsibility5</Trans>,
                            <Trans>efkangucvar_responsibility6</Trans>,
                            <Trans>efkangucvar_responsibility7</Trans>,
                            <Trans>efkangucvar_responsibility8</Trans>,
                            <Trans>efkangucvar_responsibility9</Trans>,
                          ],
                        }}
                      />
                    </div>
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>adilcetin_fullname</Trans>,
                          title: <Trans>adilcetin_title</Trans>,
                          profileImage: "img/ford-personel-adil-cetin.jpg",
                          phone: "+902165647254",
                          formattedPhone: "+90 216 564 72 54",
                          mail: "acetin4@ford.com.tr",
                          responsibilities: [
                            <Trans>adilcetin_responsibility1</Trans>,
                            <Trans>adilcetin_responsibility2</Trans>,
                            <Trans>adilcetin_responsibility3</Trans>,
                            <Trans>adilcetin_responsibility4</Trans>,
                            <Trans>adilcetin_responsibility5</Trans>,
                          ],
                        }}
                      />

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>batuhanpolat_fullname</Trans>,
                          title: <Trans>batuhanpolat_title</Trans>,
                          profileImage: "img/ford-personel-batuhan-polat.jpg",
                          phone: "+902165647866",
                          formattedPhone: "+90 216 564 78 66",
                          mail: "bpolat2@ford.com.tr",
                          responsibilities: [
                            <Trans>batuhanpolat_responsibility1</Trans>,
                            <Trans>batuhanpolat_responsibility2</Trans>,
                            <Trans>batuhanpolat_responsibility3</Trans>,
                            <Trans>batuhanpolat_responsibility4</Trans>,
                          ],
                        }}
                      />
                      {
                        <OrganizationCard
                          employee={{
                            fullname: <Trans>cemteker_fullname</Trans>,
                            title: <Trans>cemteker_title</Trans>,
                            profileImage:
                              "img/ford-personel-gokalp-babayigit.png",
                            phone: "+902165647933",
                            formattedPhone: "+90 216 564 79 33",
                            mail: "gbabay1@ford.com.tr",
                            responsibilities: [
                              <Trans>cemteker_responsibility1</Trans>,
                              <Trans>cemteker_responsibility2</Trans>,
                              <Trans>cemteker_responsibility3</Trans>,
                              <Trans>cemteker_responsibility4</Trans>,
                            ],
                          }}
                        />}

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>alikuzu_fullname</Trans>,
                          title: <Trans>alikuzu_title</Trans>,
                          profileImage: "img/ford-personel-ali-kuzu.jpg",
                          phone: "+902165647259",
                          formattedPhone: "+90 216 564 72 59",
                          mail: "akuzu@ford.com.tr",
                          responsibilities: [
                            <Trans>alikuzu_responsibility1</Trans>,
                            <Trans>alikuzu_responsibility2</Trans>,
                          ],
                        }}
                      />

                      {/* <OrganizationCard
                        employee={{
                          fullname: <Trans>yusufisik_fullname</Trans>,
                          title: <Trans>yusufisik_title</Trans>,
                          profileImage: "img/ford-personel-yusuf-isik.jpg",
                          phone: "+902165647262",
                          formattedPhone: "+90 216 564 72 62",
                          mail: "yisik2@ford.com.tr",
                          responsibilities: [
                            <Trans>yusufisik_responsibility1</Trans>,
                            <Trans>yusufisik_responsibility2</Trans>,
                            <Trans>yusufisik_responsibility3</Trans>,
                            <Trans>yusufisik_responsibility4</Trans>,
                            <Trans>yusufisik_responsibility5</Trans>,
                          ],
                        }}
                      /> */}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="#fordtrucks">
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>efkangucvar_fullname</Trans>,
                          title: <Trans>efkangucvar_title</Trans>,
                          profileImage: "img/deryagulunay.jpg",
                          phone: "+902165647263",
                          formattedPhone: "+90 216 564 72 63",
                          mail: "", //"egucvard@ford.com.tr",
                          responsibilities: [
                            <Trans>efkangucvar_responsibility1</Trans>,
                            <Trans>efkangucvar_responsibility2</Trans>,
                            <Trans>efkangucvar_responsibility3</Trans>,
                            <Trans>efkangucvar_responsibility4</Trans>,
                            <Trans>efkangucvar_responsibility5</Trans>,
                            <Trans>efkangucvar_responsibility6</Trans>,
                            <Trans>efkangucvar_responsibility7</Trans>,
                            <Trans>efkangucvar_responsibility8</Trans>,
                            <Trans>efkangucvar_responsibility9</Trans>,
                          ],
                        }}
                      />
                    </div>
                    <div className="row">
                      <OrganizationCard
                        employee={{
                          fullname: <Trans>serkanguzel_fullname</Trans>,
                          title: <Trans>serkanguzel_title</Trans>,
                          profileImage: "img/ford-personel-serkan-gazel.jpg",
                          phone: "+902165647361",
                          formattedPhone: "+90 216 564 73 61",
                          mail: "sgazel@ford.com.tr",
                          responsibilities: [
                            <Trans>serkanguzel_responsibility1</Trans>,
                            <Trans>serkanguzel_responsibility2</Trans>,
                            <Trans>serkanguzel_responsibility3</Trans>,
                            <Trans>serkanguzel_responsibility4</Trans>,
                          ],
                        }}
                      />

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>halitekiz_fullname</Trans>,
                          title: <Trans>halitekiz_title</Trans>,
                          profileImage:
                            "img/ford-personel-halit-emrah-ekiz.jpg",
                          phone: "+902165647473",
                          formattedPhone: "+90 216 564 74 73",
                          mail: "eekiz1@ford.com.tr",
                          responsibilities: [
                            <Trans>halitekiz_responsibility1</Trans>,
                            <Trans>halitekiz_responsibility2</Trans>,
                            <Trans>halitekiz_responsibility3</Trans>,
                            <Trans>halitekiz_responsibility4</Trans>,
                            <Trans>halitekiz_responsibility5</Trans>,
                            <Trans>halitekiz_responsibility6</Trans>,
                          ],
                        }}
                      />

                      <OrganizationCard
                        employee={{
                          fullname: <Trans>ozanboray_fullname</Trans>,
                          title: <Trans>ozanboray_title</Trans>,
                          profileImage: "img/ford-personel-volkan_peren.jpg",
                          phone: "+902165647731",
                          formattedPhone: "+90 216 564 77 31",
                          mail: "vperen@ford.com.tr",
                          responsibilities: [
                            <Trans>ozanboray_responsibility1</Trans>,
                            <Trans>ozanboray_responsibility2</Trans>,
                            <Trans>ozanboray_responsibility3</Trans>,
                            <Trans>ozanboray_responsibility4</Trans>,
                          ],
                        }}
                      />

                      {/* <OrganizationCard
                        employee={{
                          fullname: <Trans>erentunc_fullname</Trans>,
                          title: <Trans>erentunc_title</Trans>,
                          profileImage: "img/ford-personel-eren-tunc.png",
                          mail: "etunc2@ford.com.tr",
                          phone: "+902165647864",
                          formattedPhone: "+90 216 564 78 64",
                          responsibilities: [
                            <Trans>erentunc_responsibility1</Trans>,
                            <Trans>erentunc_responsibility2</Trans>,
                            <Trans>erentunc_responsibility3</Trans>,
                            <Trans>erentunc_responsibility4</Trans>,
                            <Trans>erentunc_responsibility5</Trans>,
                            <Trans>erentunc_responsibility6</Trans>,
                          ],
                        }}
                      /> */}

                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>

              {/* <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                >
                  
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-contact"
                  role="tabpanel"
                  aria-labelledby="nav-contact-tab"
                >
                  
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FordOrganization;
